export var ACTION;
(function (ACTION) {
    ACTION["INIT_DIGIO"] = "INIT_DIGIO";
    ACTION["CALL_DIGIO_AGAIN"] = "CALL_DIGIO_AGAIN";
    ACTION["SUCCESS_VERIFICATION"] = "SUCCESS_VERIFICATION";
    ACTION["FAILED_VERIFICATION"] = "FAILED_VERIFICATION";
})(ACTION || (ACTION = {}));
